import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PopupHeader as PrestyledPopupHeader, ScrollableContainer, } from '@streamr/tv-ui';
import styled, { css } from 'styled-components';
/**
 * Wraps content with scrollable container, changes to non-fullscreen mode at `30rem`
 * unless `fullscreenOnly` flag is raised.
 */
export function ScrollablePopupContainer({ children, fullscreenOnly = false, onCloseButtonClick, }) {
    return (_jsx(ScrollableContainer, { children: _jsxs(Outer, { "$fullscreenOnly": fullscreenOnly, children: [_jsxs("div", { children: [_jsx(Wedge, {}), _jsx(PopupHeader, { onCloseButtonClick: onCloseButtonClick })] }), _jsx(Inner, { children: children }), _jsx("div", {})] }) }));
}
const Wedge = styled.div `
    height: 1.5rem;
`;
const Inner = styled.div `
    min-height: 0;
    min-width: 0;
    max-width: var(--SettingsContainer_InnerMaxWidth, none);
    width: 100%;
    box-sizing: border-box;
    margin: 0 auto;
`;
const PopupHeader = styled(PrestyledPopupHeader) ``;
const Outer = styled.div `
    height: 100%;
    padding: 0 1.5rem;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr max-content minmax(1.5rem, 1fr);
    gap: 1rem;

    ${({ $fullscreenOnly }) => !$fullscreenOnly &&
    css `
            @media (min-width: 30rem) {
                max-height: calc(var(--vh-100, 100vh) - 4rem);
                padding: 0 1rem;
                grid-template-rows: 0 max-content 0;
                gap: 0;

                ${PopupHeader} {
                    display: none;
                }

                ${Wedge} {
                    height: 0;
                }
            }
    `}
`;
